import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import configData from "../configData.json";

function ProjectAccess({ children }) {
  const currentUser = useSelector((state) => state.authentication.currentUser);
  const location = useLocation();
  if (currentUser) {
    const isAdmin = configData.projects.includes(currentUser?.role_id);
    if (!isAdmin) {
      return (
        <Navigate to="/aceess-denied" state={{ from: location }} replace />
      );
    }
    return children;
  }
}

export default ProjectAccess;
